<h1 mat-dialog-title>
    <span class="mr-2" *ngIf="selectedWareHouseMovementTypeLabel$ | async as mt">{{ mt }} - </span>
    {{ headline$ | async }}
    <span class="ml-2 italic" *ngIf="ledgerImportAuthor$ | async as author">{{ author }}</span>
    <span class="ml-2" *ngIf="ledgerImportCommissionNumber$ | async as commissionNumber">{{ commissionNumber }}</span>
</h1>
<mat-dialog-content class="grow pb-4 gap-4">
    <div class="flex h-full" *ngIf="!startValuesForMaterialWarehouseMovementList">
        <app-loading *ngIf="loading$ | async"></app-loading>
        <div class="mat-elevation-z8 flex flex-col p-relative h-full m-2 grow" *ngIf="selectableLedgerImports$ | async as selectableLedgerImports">
            <button app-round-button class="filter-button" Inverted [matBadge]="ledgerImportFilterAmount$ | async" [matBadgeHidden]="!(ledgerImportFilterAmount$ | async)" matTooltip="Filter" [matBadgeOverlap]="true" (click)="filter.Open()">
                <fa-icon icon="filter"></fa-icon>
            </button>
            <app-filter-card UnlimitedHeight #filter [Settings]="ledgerImportFilterSettings$ | async" [Values]="ledgerImportFilterValues$ | async" [LargeCard]="true" (ValuesChange)="ledgerImportFilterValues$.next($event)"></app-filter-card>
            <app-warehouse-movement-ledger-import-select-table
                hideCheckbox
                [selectableLedgerImportIds]="selectableLedgerImports"
                (selectedLedgerImports)="selectedLedgerImportChange($event.length ? $event[0] : null)"
            ></app-warehouse-movement-ledger-import-select-table>
        </div>
        <div class="mat-elevation-z8 flex flex-col p-relative p-4 m-2" style="margin-bottom: auto" *ngIf="showFileUpload$ | async">
            <h2>Aus Datei</h2>
            <p>Hier können Sie eine CSV Datei von einem Handscanner hochladen</p>
            <app-dropzone
                #Drpzone
                [fileUploadParams]="fileUploadParams"
                [maxFiles]="1"
                autoProcess
                clearOnSuccess
                acceptedFiles=".csv,.txt,text/csv"
                style="min-height: 160px"
                (dropzoneQueueComplete)="onDropzoneQueueComplete($event)"
                (dropzoneUploadSuccess)="onDropzoneUploadSuccess($event)"
            >
            </app-dropzone>
        </div>
    </div>
    <app-material-for-warehouse-movement-list
        [defaultAddedMaterials]="defaultAddedMaterials"
        [startEntrys]="startValuesForMaterialWarehouseMovementList"
        *ngIf="startValuesForMaterialWarehouseMovementList"
    ></app-material-for-warehouse-movement-list>
</mat-dialog-content>

<mat-dialog-actions class="flex gap-4">
    <button app-button Color="cancel" Inverted mat-dialog-close="">abbrechen</button>
    <button
        app-button
        Color="cancel"
        *ngIf="!hideBackButton && startValuesForMaterialWarehouseMovementList"
        (click)="selectWareHouseMovementType(null); selectedLedgerImportChange(null); this.selectedcsv$.next(null); startValuesForMaterialWarehouseMovementList = null"
    >
        zurück
    </button>
    <button app-button style="margin-left: auto" Color="green" (click)="onConfirmClick()" *ngIf="startValuesForMaterialWarehouseMovementList">alles bestätigen</button>
</mat-dialog-actions>
